/**
 * Unified transaction types matching backend API
 * Used for POST /transactions and PUT /transactions/:id endpoints
 */

export enum UnifiedTransactionType {
  EXPENSE = 'expense',
  INCOME = 'income',
  TRANSFER = 'transfer',
  BORROW = 'borrow',
  BORROW_EXPENSE = 'borrow-expense',
  LEND = 'lend',
  REPAY = 'repay',
  COLLECT = 'collect',
  INSTALLMENT_CONVERSION = 'installment-conversion',
}

/**
 * Installment details for expense transactions
 */
export interface InstallmentPayload {
  numberOfInstallments: number;
  installmentFee?: number;
}

/**
 * Lending wallet allocation for lend transactions
 */
export interface LendingWalletPayload {
  walletId: string;
  amount: number;
}

/**
 * Expend wallet details for lend transactions with expense component
 */
export interface ExpendWalletPayload {
  walletId: string;
  amount: number;
  categoryId: string;
}

/**
 * Loan repayment allocation for repay transactions
 */
export interface LoanRepaymentAllocationPayload {
  loanId: string;
  orderIndex: number;
}

/**
 * Loan collecting allocation for collect transactions
 */
export interface LoanCollectingAllocationPayload {
  loanId: string;
  orderIndex: number;
}

/**
 * Unified payload for create/update transaction API
 * Maps to CreateUnifiedTransactionRequestDto / UpdateUnifiedTransactionRequestDto
 */
export interface UnifiedTransactionPayload {
  type: UnifiedTransactionType;
  amount: number;
  description?: string;
  transactionDate: string; // ISO string
  isExcludedFromReport?: boolean;

  // Expense/Income fields
  walletId?: string;
  categoryId?: string;
  isInstallment?: boolean;
  installment?: InstallmentPayload;

  // Transfer fields
  sourceWalletId?: string;
  destinationWalletId?: string;

  // Borrow/Repay/Collect fields
  loanWalletId?: string;
  endDate?: string; // ISO string, for borrow

  // Lend fields
  lendingWallets?: LendingWalletPayload[];
  expendWallet?: ExpendWalletPayload;

  // Repay fields
  loanRepaymentAllocation?: LoanRepaymentAllocationPayload[];

  // Collect fields
  loanCollectingAllocation?: LoanCollectingAllocationPayload[];

  // Installment conversion fields
  creditWalletId?: string;
  numberOfInstallments?: number;
  conversionDate?: string; // ISO string
}
